module.exports = window["MaterialUI"].Popover;